export default "__VITE_ASSET__CfhCCFFa__"